import { Injectable } from '@angular/core';
import { RegistrationService } from './registration.service';

export interface SaveAndContinueLaterDTO {
    success: boolean;
    fullName: string;
    email: string;
    soldoRegistrationResumeURL: string;
}

@Injectable({
    providedIn: 'root'
})
export class SaveAndContinueLaterService {

    constructor(
        private readonly registrationService: RegistrationService
    ) { }

    sendSaveAndContinueLaterEmail(lang: string): Promise<void> {
        return this.registrationService.saveAndContinueLater(lang)
    }
}
